import { render, staticRenderFns } from "./AruAutoGroupField.vue?vue&type=template&id=18aa68fb&"
import script from "./AruAutoGroupField.vue?vue&type=script&lang=js&"
export * from "./AruAutoGroupField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports